<template>
    <v-row v-if="usersLikings.length > 0">
        <v-col cols="1" class="mr-5">
            <h3 class="ma-0 kbSemiDarkBlueText--text" style="font-size: 18px; line-height: 1.2">{{ $t('general.likes') }}</h3>
            <span class="d-block kbGrayLightText--text"
                  style="cursor:pointer; font-size: 12px"
                  @click="showLikingsDialog()">{{ $t('general.seeMore') }}</span>
        </v-col>

        <v-col cols="10" class="py-0">
            <v-chip dark
                    v-for="like in topLikings"
                    :key="like.name"
                    @click="goTo(like)"
                    class="ma-1 kbBlue--text"
                    color="kbBlue"
                    outlined
                    pill>
                <v-avatar left class="kbBlue white--text">{{like.count}}</v-avatar>
                {{like.description}}
            </v-chip>
        </v-col>
        <v-dialog @input="closeLikingsDialog()" v-model="areLikingsShown">
            <v-card color="kbLight">
                <v-card-title>
                    <h3 class="kbDarkBlueText--text">{{ $t('general.peopleLikes') }}</h3>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeLikingsDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <v-text-field v-model="search"
                                          color="kbDarkBlueText"
                                          :label="`${$t('general.search')}...`"
                                          @input="filterLikings()">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-chip dark
                                    v-for="like in likings"
                                    :key="like.name"
                                    @click="goTo(like)"
                                    class="ma-1 kbBlue--text"
                                    color="kbBlue"
                                    outlined
                                    pill>
                                <v-avatar left class="kbBlue white--text">{{like.count}}</v-avatar>
                                {{like.description}}
                            </v-chip>

                            <v-chip v-if="search ? showLikings < filter.length : showLikings < usersLikings.length"
                                    @click="showLikings += 30"
                                    color="kbDarkText"
                                    outlined>
                                <v-icon small>keyboard_arrow_right</v-icon>
                                {{search ? filter.length - showLikings : usersLikings.length - showLikings}} {{ $t('general.additionalLikes') }}
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      advancedSearch: state => state.users.advancedSearch,
      selectedApp: state => state.apps.selectedApp,
      usersLikings: state => state.apps.instagramUsersLikings
    }),
    likings () {
      if (this.search) return this.filter.slice(0, this.showLikings)
      return this.usersLikings.slice(0, this.showLikings)
    },
    topLikings () {
      return this.usersLikings.slice(0, 10)
    }
  },
  created () {
    if (this.selectedApp.UUID) this.$store.dispatch('getInstagramUsersLikings')
  },
  data () {
    return {
      showLikings: 30,
      filter: [],
      search: '',
      areLikingsShown: false
    }
  },
  watch: {
    selectedApp (value) {
      if (value.UUID) {
        this.$store.dispatch('getInstagramUsersLikings')
      }
    }
  },
  methods: {
    closeLikingsDialog () {
      this.areLikingsShown = false
    },
    filterLikings () {
      this.showLikings = 30
      const search = this.search.toLowerCase()
      this.filter = this.usersLikings.filter(like => {
        const description = like.description.toLowerCase()
        return description.indexOf(search) > -1
      })
    },
    goTo (like) {
      const query = {}
      query.usersLikings = like.name
      this.$router.push({ name: 'PeopleDirectory', params: { appid: this.$store.getters.appUuid }, query })
    },
    showLikingsDialog () {
      this.areLikingsShown = true
    }
  }
}
</script>
<style lang="scss" scoped>
>>> .v-chip__content {
  cursor: pointer !important;
}
</style>
